import { action, makeObservable, observable } from 'mobx';
import _ from 'lodash';
import moment from 'moment';
import states from '../../../data/tpa-states.json';

export class HousingStore {

  @observable openModal = false;
  @observable errorCount = 0;

  @observable requiredDateValidationCheck = false;

  // Confirmation
  @observable submitSuccess = false;

  @observable confirmationId;

  // Member Information
  @observable memberInfo = {
    initReauth: '',
    memLast: '',
    memMiddle: '',
    memFirst: '',
    memberPrefName: '',
    memGender: '',
    memDOB: '',
    formDate: `${new Date().toJSON().split('T')[0]}`,
    isHomeless: '',
    isEnrolleeEligibleForAHAH: '',
    memAddr: '',
    memCity: '',
    memCounty: '',
    memState: 'Washington',
    memZip: '',
    memPhone: '',
    memEmail: '',
    memProvOne: '',
    memTribe: '',
    tribeDetails: '',
    memVet: '',
    vetDetails: '',
    provAgencyName: '',
    dateAssessmentComp: '',
    phoneType: '',
    nameOfContact: ''
  }

  @observable phoneTypesList = [
    {
      id: "Select",
      value: ''
    },
    {
      id: "Cell",
      value: "Cell"
    },
    {
      id: "Home",
      value: "Home",
    },
    {
      id: "Work",
      value: "Work"
    },
    {
      id: "Case Manager",
      value: "Case Manager"
    },
    {
      id: "Family Member",
      value: "Family Member"
    },
    {
      id: "Friend",
      value: "Friend"
    },
    {
      id: "Guardian",
      value: "Guardian"
    },
    {
      id: "Other",
      value: "Other"
    }
  ]

  @observable genderTypes = [
    {
      "name": "Select",
      "value": ""
    },
    {
      "name": "M",
      "value": "M"
    },
    {
      "name": "F",
      "value": "F"
      },
    {
      "name": "X",
      "value": "X"
    }
  ]

  @observable countyList = []

  @observable assessmentReporter = {
    reporterLast: '',
    reporterFirst: '',
    positionCred: '',
    providerAgency: '',
    signature: '',
    reporterDate: '',
    reporterEmail: '',
    reporterPhone: ''
  }

  @observable assessmentSupervisor = {
    supervisorLast: '',
    supervisorFirst: '',
    supervisorPosCred: '',
    superSignature: '',
    supervisorDate: ''
  }

  @observable enrolleeInformation = {
    enrolleeLast: '',
    enrolleeFirst: '',
    enrolleeDate: '',
    enrolleeNotes: '',
    enrolleeSignature: '',
    enrolleeConsentReceived: '',
    time: ''
  }

  @observable totalIncome = '';

  @observable housingType = '';

  @observable isClientHoused = '';

  @observable dateHoused = '';

  @observable healthNeedCat = [];

  @observable employmentRadio = '';

  @observable employmentCategories = [];

  @observable incomeCategories = [];

  @observable incomeOther = '';

  @observable incomeOtherCheck = '';

  @observable homelessRadio = '';

  @observable homelessOther = '';
 

  @observable personalInformationObj = {
    wheelChairRadio: '',
    wheelWidth: '',
    manualElectric: '',
    petRadio: '',
    serviceAnimalRadio: '',
    smokeRadio: '',
    marijuanaRadio: '',
    dischargeRadio: '',
    arrestedRadio: '',
    crimeRadio: '',
    convictedRadio: '',
    livingWithClientRadio: '',
    famPartFriend: '',
    aidField: '',
    housingPreference: '',
    rentalRadio: '',
    subsidizedHousingRadio: '',
    pastDueRadio: '',
    evictedRentalRadio: '',
    evictedDatesField: ''
  }

  @observable personalInformationCategories = [];

  @observable ahahChronicHomelessness = {
    ahahChronicRadio: '',
    ahahChronicFirstLast: ''
  };

  @observable ahahFreqResCareStay = {
    ahahFreqResRadio: '',
    ahahFreqResStayFirstLast: ''
  }

  @observable ahahLengthyInstContacts = {
    ahahLengthyRadio: '',
    ahahLengthyFirstLast: ''
  }

  @observable documentCategories = [];

  @observable suppDocRadio = '';

  @observable documentNotes = '';

  @observable assessmentCategories = [];

  @observable signatureCategories = [];

  @observable riskFactorsDocuments = [];

  @observable attachments = []

  @observable supportiveHousingPagesAHAH = [
    {title: 'Potential Enrollee Information', state: 'stepwizard-step active', href: '#', key: 0},
    {title: 'Complex Needs', state: 'stepwizard-step disabled', href: '#healthneeds', key: 1},
    {title: 'Housing Assessment', state: 'stepwizard-step disabled', href: '#housingassessment', key: 2},
    {title: 'AHAH-RAP', state: 'stepwizard-step disabled', href: '#ahah-rap', key: 3},
    {title: 'Signatures', state: 'stepwizard-step disabled', href: '#signature', key: 4},
    {title: 'Supporting Documentation', state: 'stepwizard-step disabled', href: '#documentation', key: 5},
    {title: 'Review & Submit', state: 'stepwizard-step disabled', href: '#reviewsubmit', key: 6},
  ];

  @observable supportiveHousingPagesNoAHAH = [
    {title: 'Potential Enrollee Information', state: 'stepwizard-step active', href: '#', key: 0},
    {title: 'Complex Needs', state: 'stepwizard-step disabled', href: '#healthneeds', key: 1},
    {title: 'Housing Assessment', state: 'stepwizard-step disabled', href: '#housingassessment', key: 2},
    {title: 'Signatures', state: 'stepwizard-step disabled', href: '#signature', key: 3},
    {title: 'Supporting Documentation', state: 'stepwizard-step disabled', href: '#documentation', key: 4},
    {title: 'Review & Submit', state: 'stepwizard-step disabled', href: '#reviewsubmit', key: 5}
  ]

  @observable supportiveHousingRoutesAHAH = [
    { title: 'Potential Enrollee Information', state: 'active', route: '/', key: 0 },
    { title: 'Health Needs', state: 'inactive', route: '/healthneeds', key: 1 },
    { title: 'Risk Factors', state: 'inactive', route: '/riskfactors', key: 2 },
    { title: 'Housing Assessment', state: 'inactive', route: '/housingassessment', key: 3 },
    { title: 'Strengths', state: 'inactive', route: '/strengths', key: 4 },
    { title: 'Housing Preference', state: 'inactive', route: '/housingpreference', key: 5 },
    { title: 'Personal Housing History', state: 'inactive', route: '/personalhousinghist', key: 6 },
    { title: 'Transportation Information', state: 'inactive', route: '/transportationinformation', key: 7 },
    { title: 'AHAH RAP', state: 'inactive', route: '/ahah-rap', key: 8 },
    { title: 'Signature', state: 'inactive', route: '/signature', key: 9 },
    { title: 'Documentation', state: 'inactive', route: '/documentation', key: 10 },
    { title: 'Review & Submit', state: 'inactive', route: '/reviewsubmit', key: 11 },
  ];

  @observable supportiveHousingRoutesNoAHAH = [
    { title: 'Potential Enrollee Information', state: 'active', route: '/', key: 0 },
    { title: 'Health Needs', state: 'inactive', route: '/healthneeds', key: 1 },
    { title: 'Risk Factors', state: 'inactive', route: '/riskfactors', key: 2 },
    { title: 'Housing Assessment', state: 'inactive', route: '/housingassessment', key: 3 },
    { title: 'Strengths', state: 'inactive', route: '/strengths', key: 4 },
    { title: 'Housing Preference', state: 'inactive', route: '/housingpreference', key: 5 },
    { title: 'Personal Housing History', state: 'inactive', route: '/personalhousinghist', key: 6 },
    { title: 'Transportation Information', state: 'inactive', route: '/transportationinformation', key: 7 },
    { title: 'Signature', state: 'inactive', route: '/signature', key: 8 },
    { title: 'Documentation', state: 'inactive', route: '/documentation', key: 9 },
    { title: 'Review & Submit', state: 'inactive', route: '/reviewsubmit', key: 10 },
  ];

  @action setSupportiveHousingRouteStatus(pageKey, pageState) {
    const routes = this.memberInfo.isHomeless === 'Yes' && this.memberInfo.isEnrolleeEligibleForAHAH === 'Yes' 
      ? this.supportiveHousingRoutesAHAH 
      : this.supportiveHousingRoutesNoAHAH;

    const page = _.find(routes, { route: pageKey });
    if (page) {
      page.state = pageState;
    }
  }

  @action getSupportiveHousingRouteStatus(pageKey) {
    const page = _.find((this.memberInfo.isHomeless === 'Yes' && this.memberInfo.isEnrolleeEligibleForAHAH === 'Yes' ? this.supportiveHousingRoutesAHAH : this.supportiveHousingRoutesNoAHAH), page => page.route === pageKey);
    return page.state || 'inactive';
  }


  @action setSupportiveHousingAttachmentsDetails(fileCategory, fileName, option, updatedFileName) {
    const attachment = {}
    attachment.documentName = fileCategory;
    attachment.fileName = fileName;
    attachment.option = option
    attachment.shortenedName = this.shortenDocName(fileCategory);
    attachment.updatedFileName = updatedFileName;

    this.attachments.push(attachment);
  }

  @action resetAllAttachments() {
    this.documentCategories = [];
    this.attachments = [];
  }

  @action shortenDocName(docName) {
    switch(docName) {
      // Health Needs
      case 'Mental health diagnosis':
        return 'MH Diagnosis';
      case 'Substance use disorder':
        return 'SUD Diagnosis';
      case 'Comprehensive Assessment and Reporting Evaluation':
        return 'CARE Demonstrating ADLs';
      case 'A coordinated entry assessment':
        return 'Coordinated Entry Assessment';
      case 'Other - Health Needs':
        return 'Other';
      
      // Risk Factors
      case 'Institutional Contacts':
        return 'Chronic Homelessness';
      case 'Residential Care Stays':
        return 'Residential Care Stays';
      case 'Paid Caregivers':
        return 'Paid Caregivers';
      case 'Other - Risk Factor':
        return 'Other Risk Factor';
      default:
        return docName;
    }
  }

  @action getProviderAgencyAbbr() {
    if(!this.assessmentReporter.providerAgency)
      return undefined;
    
    if(typeof this.assessmentReporter.providerAgency === 'string')
      return undefined;
    
    return this.assessmentReporter.providerAgency ? this.assessmentReporter.providerAgency.abbr : undefined;
  }

  @action getAttachment(docName) {
    let fileName;
    const attac = this.attachments.find(attac => attac.documentName === docName);
    if (attac !== undefined) {
      fileName = attac.fileName;
    }else{
      fileName = undefined;
    }
    return fileName;
  }

  @action setSupportiveHousingPageStatus(pageKey, pageState) {
    const page = _.find((this.memberInfo.isHomeless === 'Yes' && this.memberInfo.isEnrolleeEligibleForAHAH === 'Yes' ? this.supportiveHousingPagesAHAH : this.supportiveHousingPagesNoAHAH), page => page.href === pageKey);
    const pageStateString = `stepwizard-step ${pageState}`;
    page.state = pageStateString;
  }

  @action getSupportiveHousingPageStatus(pageKey) {
    const page = _.find((this.memberInfo.isHomeless === 'Yes' && this.memberInfo.isEnrolleeEligibleForAHAH === 'Yes' ? this.supportiveHousingPagesAHAH : this.supportiveHousingPagesNoAHAH), page => page.href === pageKey);
    return page.state;
  }

  @action resetSupportiveHousingPage() {
   
    this.supportiveHousingPagesAHAH = [
      {title: 'Potential Enrollee Information', state: 'stepwizard-step active', href: '#', key: 0},
      {title: 'Complex Needs', state: 'stepwizard-step disabled', href: '#healthneeds', key: 1},
      {title: 'Housing Assessment', state: 'stepwizard-step disabled', href: '#housingassessment', key: 2},
      {title: 'AHAH-RAP', state: 'stepwizard-step disabled', href: '#ahah-rap', key: 3},
      {title: 'Signatures', state: 'stepwizard-step disabled', href: '#signature', key: 4},
      {title: 'Supporting Documentation', state: 'stepwizard-step disabled', href: '#documentation', key: 5},
      {title: 'Review & Submit', state: 'stepwizard-step disabled', href: '#reviewsubmit', key: 6},
    ];
  
    this.supportiveHousingPagesNoAHAH = [
      {title: 'Potential Enrollee Information', state: 'stepwizard-step active', href: '#', key: 0},
      {title: 'Complex Needs', state: 'stepwizard-step disabled', href: '#healthneeds', key: 1},
      {title: 'Housing Assessment', state: 'stepwizard-step disabled', href: '#housingassessment', key: 2},
      {title: 'Signatures', state: 'stepwizard-step disabled', href: '#signature', key: 3},
      {title: 'Supporting Documentation', state: 'stepwizard-step disabled', href: '#documentation', key: 4},
      {title: 'Review & Submit', state: 'stepwizard-step disabled', href: '#reviewsubmit', key: 5}
    ]

  }

  @action resetSupportiveHousingRoutesStatus() {
   
    this.supportiveHousingRoutesAHAH = [
      { title: 'Potential Enrollee Information', state: 'active', route: '/', key: 0 },
      { title: 'Health Needs', state: 'inactive', route: '/healthneeds', key: 1 },
      { title: 'Risk Factors', state: 'inactive', route: '/riskfactors', key: 2 },
      { title: 'Housing Assessment', state: 'inactive', route: '/housingassessment', key: 3 },
      { title: 'Strengths', state: 'inactive', route: '/strengths', key: 4 },
      { title: 'Housing Preference', state: 'inactive', route: '/housingpreference', key: 5 },
      { title: 'Personal Housing History', state: 'inactive', route: '/personalhousinghist', key: 6 },
      { title: 'Transportation Information', state: 'inactive', route: '/transportationinformation', key: 7 },
      { title: 'AHAH RAP', state: 'inactive', route: '/ahah-rap', key: 8 },
      { title: 'Signature', state: 'inactive', route: '/signature', key: 9 },
      { title: 'Documentation', state: 'inactive', route: '/documentation', key: 10 },
      { title: 'Review & Submit', state: 'inactive', route: '/reviewsubmit', key: 11 },
    ];;
  
    this.supportiveHousingRoutesNoAHAH = [
      { title: 'Potential Enrollee Information', state: 'active', route: '/', key: 0 },
      { title: 'Health Needs', state: 'inactive', route: '/healthneeds', key: 1 },
      { title: 'Risk Factors', state: 'inactive', route: '/riskfactors', key: 2 },
      { title: 'Housing Assessment', state: 'inactive', route: '/housingassessment', key: 3 },
      { title: 'Strengths', state: 'inactive', route: '/strengths', key: 4 },
      { title: 'Housing Preference', state: 'inactive', route: '/housingpreference', key: 5 },
      { title: 'Personal Housing History', state: 'inactive', route: '/personalhousinghist', key: 6 },
      { title: 'Transportation Information', state: 'inactive', route: '/transportationinformation', key: 7 },
      { title: 'Signature', state: 'inactive', route: '/signature', key: 8 },
      { title: 'Documentation', state: 'inactive', route: '/documentation', key: 9 },
      { title: 'Review & Submit', state: 'inactive', route: '/reviewsubmit', key: 10 },
    ];

  }


  @action setIsHomeless = val => {
    this.memberInfo.isHomeless = val;
    this.clearHousingAssessmentFormOnHomelessness();
  }

  @action setIsEnrolleeEligibleForAHAH = val => {
    this.memberInfo.isEnrolleeEligibleForAHAH = val;
    this.clearHousingAssessmentFormOnHomelessness();
  }

  @action setMemberPhoneNumber = val => {
    this.memberInfo.memPhone = val;
  }

  @action setMemProvOne = val => {
    this.memberInfo.memProvOne = val;
  }

  @action setMemberInfo(memField, val) {
    switch (memField) {
      case 'memberLast':
        this.memberInfo.memLast = val;
        break;
      case 'memberMiddle':
        this.memberInfo.memMiddle = val;
        break;
      case 'memberFirst':
        this.memberInfo.memFirst = val;
        break;
      case 'memberPrefName':
        this.memberInfo.memberPrefName = val;
        break;
      case 'formDate':
        this.memberInfo.formDate = val;
        break;
      case 'memAddr':
        this.memberInfo.memAddr = val;
        break;
      case 'memCity':
        this.memberInfo.memCity = val;
        break;
      case 'memCounty':
        this.memberInfo.memCounty = val;
        break;
      case 'memZip':
        this.memberInfo.memZip = val;
        break;
      case 'memEmail':
        this.memberInfo.memEmail = val;
        break;
      case 'tribeField':
        this.memberInfo.tribeDetails = val;
        break;
      case 'vetField':
        this.memberInfo.vetDetails = val;
        break;
      case 'provAgencyField':
        this.memberInfo.provAgencyName = val;
        break;
      default:
        break;
    }
  }

  @action setAssessDate = value => {
    if(value !== null) {
      this.memberInfo.dateAssessmentComp = value;
    }
  }

  @action setMemberDateOfBirth = value => {
    if(value !== null) {
      this.memberInfo.memDOB = value;
    }
  }

  @action setMemberGenderType = value => {
    this.memberInfo.memGender = value;
  }

  @action setMemberCounty = value => {
    this.memberInfo.memCounty = value;
  }

  @action setMemberPhoneType = value => {
    this.memberInfo.phoneType = value;
    if (value === 'Cell' || value === 'Home' || value === 'Work') {
      this.memberInfo.nameOfContact = '';
    }
  }

  @action setNameOfContact = value => {
    this.memberInfo.nameOfContact = value;
  }

  @action setSignatures() {
    if (this.assessmentReporter.reporterFirst && this.assessmentReporter.reporterLast) {
      this.assessmentReporter.signature = `${this.assessmentReporter.reporterFirst} ${this.assessmentReporter.reporterLast}`;
    }
    if (this.assessmentSupervisor.supervisorFirst && this.assessmentSupervisor.supervisorLast) {
      this.assessmentSupervisor.superSignature = `${this.assessmentSupervisor.supervisorFirst} ${this.assessmentSupervisor.supervisorLast}`;
    }
    if (this.enrolleeInformation.enrolleeFirst && this.enrolleeInformation.enrolleeLast) {
      this.enrolleeInformation.enrolleeSignature = `${this.enrolleeInformation.enrolleeFirst} ${this.enrolleeInformation.enrolleeLast}`;
    }
  }

  @action setAssessmentReporterDate(value) {
    if(value !== null) {
      this.assessmentReporter.reporterDate = value;
    }
  }

  @action setAssessmentReporter(name, value) {
    switch (name) {
      case 'reporterLastField':
        this.assessmentReporter.reporterLast = value;
        if (this.assessmentReporter.reporterLast === '') {
          this.assessmentReporter.signature = '';
        }
        break;
      case 'reporterFirstField':
        this.assessmentReporter.reporterFirst = value;
        if (this.assessmentReporter.reporterFirst === '') {
          this.assessmentReporter.signature = '';
        }
        break;
      case 'positionCredField':
        this.assessmentReporter.positionCred = value;
        break;
      case 'providerAgencyField':
        this.assessmentReporter.providerAgency = value;
        break;
      case 'reporterEmailField':
        this.assessmentReporter.reporterEmail = value;
        break;
      case 'reporterPhoneField':
        this.assessmentReporter.reporterPhone = value;
        break;
      default:
        break;
    }
  }

  @action setAssessmentSupervisorDate(value) {
    if(value !== null) {
      if (value && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
        this.assessmentSupervisor.supervisorDate = value;
      } else {
        this.assessmentSupervisor.supervisorDate = '';
      }
    } else {
      this.assessmentSupervisor.supervisorDate = '';
    }
  }

  @action setAssessmentSupervisor(name, value) {
    switch (name) {
      case 'supervisorLastField':
        this.assessmentSupervisor.supervisorLast = value;
        if (this.assessmentSupervisor.supervisorLast === '') {
          this.assessmentSupervisor.superSignature = '';
        }
        break;
      case 'supervisorFirstField':
        this.assessmentSupervisor.supervisorFirst = value;
        if (this.assessmentSupervisor.supervisorFirst === '') {
          this.assessmentSupervisor.superSignature = '';
        }
        break;
      case 'supervisorPosCredField':
        this.assessmentSupervisor.supervisorPosCred = value;
        break;
      default:
        break;
    }
  }

  @action setEnrolleeInfoDate(value) {
    if(value !== null) {
      this.enrolleeInformation.enrolleeDate = value;
    }
  }

  @action setEnrolleeInfo(name, value) {
    switch (name) {
      case 'enrolleeLastField':
        this.enrolleeInformation.enrolleeLast = value;
        break;
      case 'enrolleeFirstField':
        this.enrolleeInformation.enrolleeFirst = value;
        break;
      case 'enrolleeNotesField':
        this.enrolleeInformation.enrolleeNotes = value;
        break;
      default:
        break;
    }
  }

  @action setTimeConsentReceived(value) {
  const hour = parseInt(value.substr(0, 2));
  
  if (hour === 0) {
    // 00:xx -> 12:xx AM (midnight)
    const hour12 = value.replace("00", "12");
    this.enrolleeInformation.time = hour12 + ' AM';
  } else if (hour < 12) {
    // 01:xx - 11:xx -> 1:xx - 11:xx AM
    this.enrolleeInformation.time = value + ' AM';
  } else if (hour === 12) {
    // 12:xx -> 12:xx PM (noon)
    this.enrolleeInformation.time = value + ' PM';
  } else {
    // 13:xx - 23:xx -> 1:xx - 11:xx PM
    const hour12 = value.replace(`${hour}`, `${hour - 12}`);
    this.enrolleeInformation.time = hour12 + ' PM';
  }

  this.enrolleeInformation.enrolleeConsentReceived = value;
  return undefined;
}

  @action setHealthNeedCat(value) {
    this.healthNeedCat = value;
  }

  @action setEmploymentCategories(value) {
    this.employmentCategories = value;
  }

  @action setIncomeCategories(value) {
    this.incomeCategories = value;
  }

  @action setDocumentCategories(value) {
    this.documentCategories = value;
  }

  @action setRiskFactorsDocuments(value) {
    this.riskFactorsDocuments = value;
  }

  @action getRiskFactorsDocuments() {
    return this.riskFactorsDocuments.values;
  }


  @action setAssessmentCategories(value) {
    this.assessmentCategories = value;
  }

  @action setSignatureCategories(value) {
    this.signatureCategories = value;
  }

  @observable currentDate = moment().format("MM/DD/YYYY");

  @observable blocking;

  constructor() {
    makeObservable(this);
    this.states = states;
  }

  @action setDocumentNotes(value) {
    this.documentNotes = value;
  }

  @action setInitReAuth(value) {
    this.memberInfo.initReauth = value;
  }

  @action setMemberState(state) {
    this.memberInfo.memState = state;
  }

  @action setMemberTribeDetails(value) {
    this.memberInfo.memTribe = value;
    this.memberInfo.tribeDetails = '';
  }

  @action setMemberVeteranDetails(value) {
    this.memberInfo.memVet = value;
    this.memberInfo.vetDetails = '';
  }

  @action setIncomeOther(value) {
    this.incomeOther = value;
  }

  @action setTotalIncome(value) {
    this.totalIncome = value;
  }

  @action setHousingType(value) {
    this.housingType = value;
    if (value !== "Not housed (homeless)") {
      this.homelessRadio = '';
      this.homelessOther = '';
    }
  }

  @action setIsClientHoused(value) {
    this.isClientHoused = value;
    if (value === 'Yes') {
      this.homelessRadio = '';
      this.homelessOther = '';
    } else if (value === 'No') {
      this.dateHoused = '';
    }
  }

  @action setDateHoused(value) {
    this.dateHoused = value;
  }

  @action setHomelessRadio(value) {
    this.homelessRadio = value;
    if (value !== 'Other') {
      this.homelessOther = '';
    }
  }

  @action setHomelessOther(value) {
    this.homelessOther = value;
  }

  @action setwheelChairRadio(value) {
    this.personalInformationObj.wheelChairRadio = value;
  }

  @action setlivingWithClientRadio(value) {
    this.personalInformationObj.livingWithClientRadio = value;
  }

  @action setPetOption(value) {
    this.personalInformationObj.petRadio = value;
  }

  @action setServiceAnimalOption(value) {
    this.personalInformationObj.serviceAnimalRadio = value;
  }

  @action setSmokeOption(value) {
    this.personalInformationObj.smokeRadio = value;
  }

  @action setMarijuanaOption(value) {
    this.personalInformationObj.marijuanaRadio = value;
  }

  @action setDischargeOption(value) {
    this.personalInformationObj.dischargeRadio = value;
  }

  @action setArrestedRadio(value) {
    this.personalInformationObj.arrestedRadio = value;
  }

  @action setCrimeOption(value) {
    this.personalInformationObj.crimeRadio = value;
  }

  @action setConvictedOption(value) {
    this.personalInformationObj.convictedRadio = value;
  }

  @action setRentalOption(value) {
    this.personalInformationObj.rentalRadio = value;
  }

  @action setSubsidizedHousingOption(value) {
    this.personalInformationObj.subsidizedHousingRadio = value;
  }

  @action setPastDueOption(value) {
    this.personalInformationObj.pastDueRadio = value;
  }

  @action setEvictedRentalOption(value) {
    this.personalInformationObj.evictedRentalRadio = value;
  }

  @action setPersonalInfo(name, value) {
    switch (name) {
      case 'wheelchairWidth':
        this.personalInformationObj.wheelWidth = value;
        break;
      case 'famPartFriendField':
        this.personalInformationObj.famPartFriend = value;
        break;
      case 'aidFieldOption':
        this.personalInformationObj.aidField = value;
        break;
      case 'housingPreferenceField':
        this.personalInformationObj.housingPreference = value;
        break;
      case 'evictedDatesFieldOption':
        this.personalInformationObj.evictedDatesField = value;
        break;
      default:
        break;
    }
  }

  @action setSuppDocRadio(value) {
    this.suppDocRadio = value;
  }

  @action setWheelChairRadio(value) {
    this.wheelChairRadio = value;
  }

  @action setWheelWidth(value) {
    this.wheelWidth = value;
  }

  @action setManualElectric(value) {
    this.personalInformationObj.manualElectric = value;
  }

  @action changeDateFormat(date) {
    if (date && (/^\d{4}-\d\d-\d\d$/.test(date) || /^\d\d\/\d\d\/\d{4}$/.test(date))) {
      // if it's a valid date
      if (date.indexOf('-') > -1) {
        // it's in yyyy-mm-dd format
        const [year, month, day] = date.split('-');
        return `${month}/${day}/${year}`;
      }
      if (date.indexOf('/') > -1) {
        // it's in mm-dd-yyyy format
        const [month, day, year] = date.split('/');
        return `${month}/${day}/${year}`;
      }
      return date;
    }
    // else it's not a valid date... not sure what you want to do.
    return date;
  }

  @action turnOnBlocking() {
    this.blocking = true;
  }

  @action turnOffBlocking() {
    this.blocking = false;
  }

  // Complex Needs - Risk Factors
  @observable riskFactorsCategories = [];

  // Risk Factors
  @observable countDetails = '';

  @observable multiResidentialCare = '';

  @observable multiInHomeCare = '';

  @observable additionalDetails = '';
  // Risk Factors

  // Risk FactorsCat Radios
  @observable institutionalSettingsRadio = '';

  @observable multiInstSettingsRadio = '';

  @observable multiResidentialCareRadio = '';

  @observable multiInHomeCareRadio = '';
  // Risk FactorsCat

  @observable instSettingsCategories = [];

  @observable resCareFacilityCategories = [];

  /* Complex Needs - Risk Factors Details */

  @action setRiskFactorCategories(value) {
    this.riskFactorsCategories = value;
    if (this.riskFactorsCategories.indexOf('Institutional Contacts') < 0) {
      this.institutionalSettingsRadio = '';
      this.instSettingsCategories = [];
      this.multiInstSettingsRadio = '';
      this.countDetails = '';
    }
    if (this.riskFactorsCategories.indexOf('Residential Care') < 0) {
      this.multiResidentialCareRadio = '';
      this.resCareFacilityCategories = [];
    }
    if (this.riskFactorsCategories.indexOf('In Home Care') < 0) {
      this.multiInHomeCareRadio = '';
    }
  }

  @action setInstSettingsCategories(value) {
    this.instSettingsCategories = value;
  }

  @action setResCareFacilityCategories(value) {
    this.resCareFacilityCategories = value;
  }

  @action setInstitutionalSettings(value) {
    this.institutionalSettingsRadio = value;
    if (this.institutionalSettingsRadio === 'No') {
      this.instSettingsCategories = [];
    }
  }

  @action setMultiInstSettings(value) {
    this.multiInstSettingsRadio = value;
    if (this.multiInstSettingsRadio === 'No') {
      this.countDetails = '';
    }
  }

  @action setCountDetails(value) {
    this.countDetails = value;
  }

  @action setMultiResidentialCare(value) {
    this.multiResidentialCareRadio = value;
    if (this.multiResidentialCareRadio === 'No') {
      this.resCareFacilityCategories = [];
    }
  }

  @action setMultiInHomeCare(value) {
    this.multiInHomeCareRadio = value;
  }

  @action updateAdditionalDetails(details) {
    this.additionalDetails = details;
  }

  /* Complex Needs - Risk Factors Details */

  // Housing Assessment - Strengths

  @observable strengthsCategories = [];

  @observable otherStrengths = '';

  /* Housing Assessment - Strengths Details */

  @action setHousingAssessmentStrCategories(value) {
    this.strengthsCategories = value;
  }

  @action updateOtherStrengths(value) {
    this.otherStrengths = value;
  }

  /* Housing Assessment - Strengths Details */

  // Housing Assessment - Housing Preference Settings
  @observable housingPreferenceCat = [];

  /* Housing Assessment - Housing Preference Settings Details */

  @action setHousingPreferenceCategories(value) {
    this.housingPreferenceCat = value;
  }

  /* Housing Assessment - Housing Preference Settings Details */

  // Housing Assessment - Close To
  @observable closeToCat = [];

  @observable otherCloseTo = '';


  /* Housing Assessment - Close To Details */

  @action setCloseToCategories(value) {
    this.closeToCat = value;
  }

  @action setOtherCloseToDetails(value) {
    this.otherCloseTo = value;
  }

  /* Housing Assessment - Close To Details */


  // Housing Assessment - Living Space

  @observable livingSpaceCat = [];

  @observable housingPreferenceDescription = '';

  /* Housing Assessment - Living Space Details */

  @action setLivingSpaceCategories(value) {
    this.livingSpaceCat = value;
  }

  @action updateHousingPreferenceDescription(value) {
    this.housingPreferenceDescription = value;
  }

  /* Housing Assessment - Living Space Details */

  // Housing Assessment - Housing Goals
  @observable housingGoalsSet = '';
  
  @observable housingGoalsCount = '';
  
  @observable housingGoalsConfidence = '';

  /* Housing Assessment - Housing Goals Details */

  @observable currentHousingType = '';
  
  @observable currentHousingTypeOther = '';

  /* Housing Assessment - Current Housing Type Details */

  @observable housingAtRisk = '';
  
  @observable housingAtRiskReasons = [];
  
  @observable housingAtRiskOther = '';

  /* Housing Assessment - Housing At Risk Details */

  @observable preferredHousingType = '';
  
  @observable preferredHousingTypeOther = '';

  /* Housing Assessment - Preferred Housing Type Details */

  @observable preferredHousingLocation = '';


  // Housing Assessment - Transportation Information

  @observable publicTrasportationRadio = '';

  @observable vehicleRadio = '';

  @observable transportationDescription = '';

  /* Housing Assessment - Transportation Information Details */

  @action setPublicTransportRadio(value) {
    this.publicTrasportationRadio = value;
  }

  @action setVehicleRadio(value) {
    this.vehicleRadio = value;
  }

  @action updateTransportationDescription(value) {
    this.transportationDescription = value;
  }

  /* Housing Assessment - Transportation Information Details */

  /* Housing Assessment - Housing Goals Actions */

  @action setHousingGoalsSet(value) {
    this.housingGoalsSet = value;
    if (value === 'No') {
      this.housingGoalsCount = '';
      this.housingGoalsConfidence = '';
    }
  }

  @action setHousingGoalsCount(value) {
    this.housingGoalsCount = value;
  }

  @action setHousingGoalsConfidence(value) {
    this.housingGoalsConfidence = value;
  }

  /* Housing Assessment - Current Housing Type Actions */

  @action setCurrentHousingType(value) {
    this.currentHousingType = value;
    if (value !== 'Other') {
      this.currentHousingTypeOther = '';
    }
  }

  @action setCurrentHousingTypeOther(value) {
    this.currentHousingTypeOther = value;
  }

  /* Housing Assessment - Housing At Risk Actions */

  @action setHousingAtRisk(value) {
    this.housingAtRisk = value;
    if (value === 'No') {
      this.housingAtRiskReasons = [];
      this.housingAtRiskOther = '';
    }
  }

  @action setHousingAtRiskReasons(value) {
    this.housingAtRiskReasons = value;
    if (value.indexOf('Other') < 0) {
      this.housingAtRiskOther = '';
    }
  }

  @action setHousingAtRiskOther(value) {
    this.housingAtRiskOther = value;
  }

  /* Housing Assessment - Preferred Housing Type Actions */

  @action setPreferredHousingType(value) {
    this.preferredHousingType = value;
    if (value !== 'Other') {
      this.preferredHousingTypeOther = '';
    }
  }

  @action setPreferredHousingTypeOther(value) {
    this.preferredHousingTypeOther = value;
  }

  /* Housing Assessment - Preferred Housing Location Actions */

  @action setPreferredHousingLocation(value) {
    this.preferredHousingLocation = value;
  }

  /* AHAH RAP */

  @action setAHAHChronicRadio(value) {
    this.ahahChronicHomelessness.ahahChronicRadio = value;
    if(value === 'No') {
      this.ahahChronicHomelessness.ahahChronicFirstLast = '';
    }
  }

  @action setAHAHChronicFirstLast(value) {
    this.ahahChronicHomelessness.ahahChronicFirstLast = value;
  }

  @action setAHAHFreqResRadio(value) {
    this.ahahFreqResCareStay.ahahFreqResRadio = value;
    if(value === 'No') {
      this.ahahFreqResCareStay.ahahFreqResStayFirstLast = '';
    }
  }

  @action setAHAHFreqResFirstLast(value) {
    this.ahahFreqResCareStay.ahahFreqResStayFirstLast = value;
  }

  @action setAHAHLengthRadio(value) {
    this.ahahLengthyInstContacts.ahahLengthyRadio = value;
    if(value === 'No') {
      this.ahahLengthyInstContacts.ahahLengthyFirstLast = '';
    }
  }

  @action setAHAHLengthFirstLast(value) {
    this.ahahLengthyInstContacts.ahahLengthyFirstLast = value;
  }

  /* AHAH RAP */

  // Housing Assessment - Housing options

  @observable rentalAssistanceCat = [];

  @observable otherRentalAssistanceDetails = '';

  /* Housing Assessment - Housing options Details */

  @observable individualHousingRadio = '';

  @action setIndividualHousingRadio(value) {
    this.individualHousingRadio = value;
    if (this.individualHousingRadio === 'No') {
      this.rentalAssistanceCat = [];
    }
  }

  @action updateIndividualHousingOptions(value) {
    if (value === 'No') {
      this.rentalAssistanceCat = [];
    }
  }

  @action setRentalAssistanceCat(value) {
    this.rentalAssistanceCat = value;
  }

  @action setOtherRentalAssistanceDetails(value) {
    this.otherRentalAssistanceDetails = value;
  }

  /* Housing Assessment - Housing options Details */

  @observable rentalSubsidyCategories = [];

  @observable otherRentalSubsidyDetails = '';

  /* Housing Assessment - Project-based Rental subsidy Details */

  @action setRentalSubsidyCategories(value) {
    this.rentalSubsidyCategories = value;
  }

  @action setOtherRentalSubsidyDetails(value) {
    this.otherRentalSubsidyDetails = value;
  }

  /* Housing Assessment - Project-based Rental subsidy Details */

  // Housing Assessment - Continuum Of Care

  @observable continuumOfCareCat = [];

  @observable otherContinuumOfCareDetails = '';

  @observable deptOfCommerceSubsidized = '';

  @observable otherHUDOrUSDASubsidy = '';

  @observable countyOrCityProgram = '';

  @observable otherProgramsDetails = '';

  /* Housing Assessment - Continuum Of Care Details */

  @action setContinuumOfCareCat(value) {
    this.continuumOfCareCat = value;
  }

  @action setOtherContinuumOfCareDetails(value) {
    this.otherContinuumOfCareDetails = value;
  }

  @action updateDeptOfCommerceSubsidized(value) {
    this.deptOfCommerceSubsidized = value;
  }

  @action updateOtherHUDOrUSDASubsidy(value) {
    this.otherHUDOrUSDASubsidy = value;
  }

  @action updateCountyOrCityProgramField(value) {
    this.countyOrCityProgram = value;
  }

  @action updateOtherProgramsField(value) {
    this.otherProgramsDetails = value;
  }

  /* Housing Assessment - Continuum Of Care Details */

  @action setOpenModal() {
    this.openModal = !this.openModal;
  }

  @action incrementErrorCount() {
    if (this.errorCount + 1 === 3) {
      this.errorCount = 0;
    } else {
      this.errorCount = this.errorCount + 1;
    }
  }

  @action resetErrorCount() {
    this.errorCount = 0;
  }

  
  @action setCountyList(list) {
    this.countyList = list;
  }

  @action getCountyListCount() {
    return this.countyList.length;
  }


  @observable housingAssessmentFormData = {
    application: 'Provider Portal - Public',
    state: 'WA',
    brand: 'AGP',
    dateAssessmentCompleted: '',
    dateReceived: '',
    enrollee: {
      address: '',
      city: '',
      county: '',
      dateOfBirth: '',
      email: '',
      firstName: '',
      preferredName: '',
      gender: '',
      isHomeless: '',
      lastName: '',
      memberOfTribe: '',
      middleInitial: '',
      militaryBranch: '',
      phoneNumber: '',
      phoneNumberType: '',
      nameOfContact: '',
      otherPhoneNumberType: '',
      providerOneId: '',
      state: '',
      tribe: '',
      veteran: '',
      zip: ''
    },
    enrolleeConsent: {
      date: '',
      time: '',
      firstName: '',
      lastName: '',
      Acknowledgements: [],
      Attestations: []
    },
    initialOrReauth: '',
    notes: '',
    providerAgency: {
      name: '',
      reporter: {
        date: '',
        firstName: '',
        lastName: '',
        positionCredentials: '',
        email: '',
        phoneNumber: ''
      },
      supervisor: {
        date: '',
        firstName: '',
        lastName: '',
        positionCredentials: ''
      }
    },
    questions: [],
    serviceType: "Supportive Housing",
    attachments: []
  }

  @action clearHousingAssessmentForm() {

    this.confirmationId = undefined;
    this.suppDocRadio = '';

    // Form objects
    this.memberInfo = {
      initReauth: '',
      memLast: '',
      mem: '',
      memFirst: '',
      memGender: '',
      memDOB: '',
      formDate: `${new Date().toJSON().split('T')[0]}`,
      isHomeless: 'N/A',
      memAddr: '',
      memCity: '',
      memCounty: '',
      memState: 'Washington',
      memZip: '',
      memPhone: '',
      memEmail: '',
      memProvOne: '',
      memTribe: '',
      tribeDetails: '',
      memVet: '',
      vetDetails: '',
      provAgencyName: '',
      dateAssessmentComp: '',
      phoneType: ''
    }

    this.assessmentReporter = {
      reporterLast: '',
      reporterFirst: '',
      positionCred: '',
      providerAgency: '',
      signature: '',
      reporterDate: ''
    }

    this.assessmentSupervisor = {
      supervisorLast: '',
      supervisorFirst: '',
      supervisorPosCred: '',
      superSignature: '',
      supervisorDate: ''
    }

    this.enrolleeInformation = {
      enrolleeLast: '',
      enrolleeFirst: '',
      enrolleeDate: '',
      enrolleeNotes: '',
      enrolleeSignature: ''
    }

    this.totalIncome = '';

    this.housingType = '';

    this.isClientHoused = '';

    this.dateHoused = '';

    this.healthNeedCat = [];

    this.employmentRadio = '';

    this.employmentCategories = [];

    this.incomeCategories = [];

    this.incomeOther = '';

    this.incomeOtherCheck = '';

    this.homelessRadio = '';

    this.homelessOther = '';

    this.personalInformationObj = {
      wheelChairRadio: '',
      wheelWidth: '',
      manualElectric: '',
      petRadio: '',
      serviceAnimalRadio: '',
      smokeRadio: '',
      marijuanaRadio: '',
      dischargeRadio: '',
      arrestedRadio: '',
      crimeRadio: '',
      convictedRadio: '',
      livingWithClientRadio: '',
      famPartFriend: '',
      aidField: '',
      housingPreference: '',
      rentalRadio: '',
      subsidizedHousingRadio: '',
      pastDueRadio: '',
      evictedRentalRadio: '',
      evictedDatesField: ''
    }

    this.ahahChronicHomelessness = {
      ahahChronicRadio: '',
      ahahChronicFirstLast: ''
    };
  
    this.ahahFreqResCareStay = {
      ahahFreqResRadio: '',
      ahahFreqResStayFirstLast: ''
    };
  
    this.ahahLengthyInstContacts = {
      ahahLengthyRadio: '',
      ahahLengthyFirstLast: ''
    };

    this.documentCategories = [];

    this.documentNotes = '';

    this.assessmentCategories = [];

    this.signatureCategories = [];

    this.riskFactorsCategories = [];

    this.countDetails = '';
    this.multiResidentialCare = '';
    this.multiInHomeCare = '';
    this.additionalDetails = '';

    this.instSettingsCategories = [];

    this.resCareFacilityCategories = [];

    this.strengthsCategories = [];

    this.otherStrengths = '';

    this.housingPreferenceCat = [];

    this.closeToCat = [];

    this.otherCloseTo = '';

    this.livingSpaceCat = [];

    this.housingPreferenceDescription = '';

    this.publicTrasportationRadio = '';

    this.vehicleRadio = '';

    this.transportationDescription = '';

    this.individualHousingRadio = '';

    this.rentalAssistanceCat = [];

    this.otherRentalAssistanceDetails = '';

    this.rentalSubsidyCategories = [];

    this.otherRentalSubsidyDetails = '';

    this.continuumOfCareCat = [];

    this.otherContinuumOfCareDetails = '';

    this.deptOfCommerceSubsidized = '';

    this.otherHUDOrUSDASubsidy = '';

    this.countyOrCityProgram = '';

    this.otherProgramsDetails = '';

    this.housingGoalsSet = '';
    this.housingGoalsCount = '';
    this.housingGoalsConfidence = '';
    this.currentHousingType = '';
    this.currentHousingTypeOther = '';
    this.housingAtRisk = '';
    this.housingAtRiskReasons = [];
    this.housingAtRiskOther = '';
    this.preferredHousingType = '';
    this.preferredHousingTypeOther = '';
    this.preferredHousingLocation = '';

    // Form objects

    this.housingAssessmentFormData = {
      application: 'Provider Portal - Public',
      state: 'WA',
      brand: 'AGP',
      dateAssessmentCompleted: '',
      dateReceived: '',
      enrollee: {
        address: '',
        city: '',
        county: '',
        dateOfBirth: '',
        email: '',
        firstName: '',
        preferredName: '',
        gender: '',
        isHomeless: '',
        lastName: '',
        memberOfTribe: '',
        middleInitial: '',
        militaryBranch: '',
        phoneNumber: '',
        phoneNumberType: '',
        nameOfContact: '',
        otherPhoneNumberType: '',
        providerOneId: '',
        state: '',
        tribe: '',
        veteran: '',
        zip: ''
      },
      enrolleeConsent: {
        date: '',
        time: '',
        firstName: '',
        lastName: '',
        Acknowledgements: [],
        Attestations: []
      },
      initialOrReauth: '',
      notes: '',
      providerAgency: {
        name: '',
        reporter: {
          date: '',
          firstName: '',
          lastName: '',
          positionCredentials: '',
          email: '',
          phoneNumber: ''
        },
        supervisor: {
          date: '',
          firstName: '',
          lastName: '',
          positionCredentials: ''
        }
      },
      questions: [],
      serviceType: "Supportive Housing",
      attachments: []
    }
  }

  @action submitHousingAssessmentForm() {

    const qArr = [];

    /* Potential Enrollee Info */

    // Initial Assessment or Reauthorization
    this.housingAssessmentFormData.initialOrReauth = this.memberInfo.initReauth;

    // Member Form Dates
    this.housingAssessmentFormData.dateReceived = moment().format("YYYY-MM-DD");
    this.housingAssessmentFormData.dateAssessmentCompleted = moment(this.memberInfo.dateAssessmentComp).format("YYYY-MM-DD");

    // Member (Potential Enrollee) Information
    this.housingAssessmentFormData.enrollee.firstName = this.memberInfo.memFirst;
    this.housingAssessmentFormData.enrollee.lastName = this.memberInfo.memLast;
    this.housingAssessmentFormData.enrollee.middleInitial = this.memberInfo.memMiddle;
    this.housingAssessmentFormData.enrollee.preferredName = this.memberInfo.memberPrefName;
    this.housingAssessmentFormData.enrollee.gender = this.memberInfo.memGender;
    this.housingAssessmentFormData.enrollee.dateOfBirth = this.memberInfo.memDOB ? moment(this.memberInfo.memDOB).format("YYYY-MM-DD") : "";
    this.housingAssessmentFormData.enrollee.isHomeless = this.memberInfo.isHomeless;
    this.housingAssessmentFormData.enrollee.zip = this.memberInfo.memZip
    this.housingAssessmentFormData.enrollee.providerOneId = this.memberInfo.memProvOne + 'WA';
    this.housingAssessmentFormData.enrollee.state = this.memberInfo.memState;
    this.housingAssessmentFormData.enrollee.county = this.memberInfo.memCounty;

    if (this.memberInfo.memAddr) {
      this.housingAssessmentFormData.enrollee.address = this.memberInfo.memAddr;
    }

    if (this.memberInfo.memCity) {
      this.housingAssessmentFormData.enrollee.city = this.memberInfo.memCity;
    }

    if (this.memberInfo.memPhone) {
      this.housingAssessmentFormData.enrollee.phoneNumber = this.memberInfo.memPhone;
    }

    if (this.memberInfo.phoneType) {
      this.housingAssessmentFormData.enrollee.phoneNumberType = this.memberInfo.phoneType;

      if (this.memberInfo.phoneType === 'Case Manager' ||
        this.memberInfo.phoneType === 'Family Member' || this.memberInfo.phoneType === 'Friend' ||
        this.memberInfo.phoneType === 'Guardian') {
        this.housingAssessmentFormData.enrollee.nameOfContact = this.memberInfo.nameOfContact;
      }

      if (this.memberInfo.phoneType === 'Other') {
        this.housingAssessmentFormData.enrollee.otherPhoneNumberType = this.memberInfo.nameOfContact;
      }
    }

    if (this.memberInfo.memEmail) {
      this.housingAssessmentFormData.enrollee.email = this.memberInfo.memEmail;
    }

    if (this.memberInfo.memTribe) {
      this.housingAssessmentFormData.enrollee.memberOfTribe = this.memberInfo.memTribe;
      this.housingAssessmentFormData.enrollee.tribe = this.memberInfo.tribeDetails;
    }

    if (this.memberInfo.memVet) {
      this.housingAssessmentFormData.enrollee.veteran = this.memberInfo.memVet;
      this.housingAssessmentFormData.enrollee.militaryBranch = this.memberInfo.vetDetails;
    }
    /* Potential Enrollee Info */

    // Health Needs
    const qhNeedObj = {
      questionId: 'Q1',
      answers: []
    };

    if (this.healthNeedCat.indexOf('opt1') >= 0) {
      qhNeedObj.answers.push('A1');
    }

    if (this.healthNeedCat.indexOf('opt2') >= 0) {
      qhNeedObj.answers.push('A2');
    }

    if (this.healthNeedCat.indexOf('opt3') >= 0) {
      qhNeedObj.answers.push('A3');
    }

    if (this.healthNeedCat.indexOf('opt4') >= 0) {
      qhNeedObj.answers.push('A4');
    }

    if (qhNeedObj.answers.length !== 0) {
      qArr.push(qhNeedObj);
    }
    // Health Needs

    // Risk Factors - Complex Needs
    if (this.riskFactorsCategories.indexOf("Chronically Homeless") >= 0) {   // Chronically homeless
      qArr.push({
        questionId: 'Q2',
        answers: ['A5']
      })
    }

    if (this.riskFactorsCategories.indexOf("Institutional Contacts") >= 0) {   // Frequent or lengthy institutional contacts
      qArr.push({
        questionId: 'Q3',
        answers: ['A6']
      })
    }

    if (this.institutionalSettingsRadio) {   // Is the client transitioning out of an institutional setting? Yes or No
      qArr.push({
        questionId: 'Q4',
        answers: [`${this.institutionalSettingsRadio === 'Yes' ? 'A7' : 'A8'}`]
      })
    }

    const riskFactQ5 = {
      questionId: 'Q5',
      answers: []
    };

    if (this.instSettingsCategories.indexOf("Nursing") >= 0) {
      riskFactQ5.answers.push(`A9`);  // Nursing
    }

    if (this.instSettingsCategories.indexOf("Inpatient psychiatric hospital") >= 0) {
      riskFactQ5.answers.push(`A10`);  // Inpatient psychiatric hospital
    }

    if (this.instSettingsCategories.indexOf("Inpatient medical hospital") >= 0) {
      riskFactQ5.answers.push(`A11`);  // Inpatient medical hospital
    }

    if (this.instSettingsCategories.indexOf("Correctional program or institution") >= 0) {
      riskFactQ5.answers.push(`A12`);  // Correctional program or institution
    }

    if (this.instSettingsCategories.indexOf("Foster care facility or other youth facility") >= 0) {
      riskFactQ5.answers.push(`A13`);  // Foster care facility or other youth facility
    }

    if (riskFactQ5.answers.length !== 0) {
      qArr.push(riskFactQ5);
    }

    if (this.multiInstSettingsRadio) {   // Has the client resided within one of the previously listed institutional ?
      qArr.push({
        questionId: 'Q6',
        answers: [`${this.multiInstSettingsRadio === 'Yes' ? 'A14' : 'A15'}`]
      });
    }

    if (this.countDetails) {
      qArr.push({
        questionId: 'Q7',
        answers: [`${this.countDetails}`]
      });
    }

    if (this.riskFactorsCategories.indexOf("Residential Care") >= 0) {   // Frequent residential care stays
      qArr.push({
        questionId: 'Q8',
        answers: ['A16']
      })
    }

    if (this.multiResidentialCareRadio) {   // Has the client resided within a residential care facility two or more?
      qArr.push({
        questionId: 'Q9',
        answers: [`${this.multiResidentialCareRadio === 'Yes' ? 'A17' : 'A18'}`]
      });
    }

    const riskFactQ10 = {
      questionId: 'Q10',
      answers: []
    };

    // If yes, select all that apply

    if (this.resCareFacilityCategories.indexOf("Evaluation and treatment facility") >= 0) {
      riskFactQ10.answers.push(`A19`);
    }

    if (this.resCareFacilityCategories.indexOf("Detox center") >= 0) {
      riskFactQ10.answers.push(`A20`);
    }

    if (this.resCareFacilityCategories.indexOf("Inpatient substance use treatment facility") >= 0) {
      riskFactQ10.answers.push(`A21`);
    }

    if (this.resCareFacilityCategories.indexOf("Adult residential care, assisted living or adult family home (AFH)") >= 0) {
      riskFactQ10.answers.push(`A22`);
    }

    if (riskFactQ10.answers.length !== 0) {
      qArr.push(riskFactQ10);
    }

    if (this.riskFactorsCategories.indexOf("In Home Care") >= 0) {    // Frequent turnover of in-home caregivers
      qArr.push({
        questionId: 'Q11',
        answers: ['A23']
      });
    }

    if (this.multiInHomeCareRadio) {    // Within the last 12 months, has the client used three (or more)?
      qArr.push({
        questionId: 'Q12',
        answers: [`${this.multiInHomeCareRadio === 'Yes' ? 'A24' : 'A25'}`]
      });
    }


    // Risk Factors - Complex Needs
    if (this.riskFactorsCategories.indexOf("Prism Score") >= 0) {
      qArr.push(
        {
          questionId: 'Q13',    // PRISM predictive risk score of 1.5 or above (contact the TPA, MCO, BHO, Health Home or HCS case manager to obtain the PRISM risk score).
          answers: [
            'A26'
          ]
        }
      );
    }

    if (this.additionalDetails) {
      qArr.push(
        {
          questionId: 'Q14',    // Additional details on risk factors
          answers: [
            `${this.additionalDetails}`
          ]
        }
      );
    }

    const employQ15 = {
      questionId: 'Q15',
      answers: []
    };

    // Employment Status
    if (this.employmentCategories.indexOf('Unemployed') >= 0) {
      employQ15.answers.push('A27');
    }

    if (this.employmentCategories.indexOf('Employed part time') >= 0) {
      employQ15.answers.push('A28');
    }

    if (this.employmentCategories.indexOf('Employed full time') >= 0) {
      employQ15.answers.push('A29');
    }

    if (this.employmentCategories.indexOf('Nonpaid employment activities') >= 0) {
      employQ15.answers.push('A30');
    }

    if (this.employmentCategories.indexOf('Enrolled in training/education program') >= 0) {
      employQ15.answers.push('A31');
    }

    if (employQ15.answers.length !== 0) {
      qArr.push(employQ15);
    }

    const incomeQ16 = {
      questionId: 'Q16',
      answers: []
    }

    // Income Source
    if (this.incomeCategories.indexOf('Social Security (SSA)') >= 0) {
      incomeQ16.answers.push('A33');
    }

    if (this.incomeCategories.indexOf('Pension') >= 0) {
      incomeQ16.answers.push('A34');
    }

    if (this.incomeCategories.indexOf('Supplemental Security Income (SSI)') >= 0) {
      incomeQ16.answers.push('A35');
    }

    if (this.incomeCategories.indexOf('Social Security Disability Insurance (SSDI)') >= 0) {
      incomeQ16.answers.push('A36');
    }

    if (this.incomeCategories.indexOf('Temporary Assistance for Needy Families (TANF)') >= 0) {
      incomeQ16.answers.push('A37');
    }

    if (this.incomeCategories.indexOf('Housing and Essential Needs (HEN)') >= 0) {
      incomeQ16.answers.push('A38');
    }

    if (this.incomeCategories.indexOf('Aged, Blind, or Disabled (ABD)') >= 0) {
      incomeQ16.answers.push('A39');
    }

    if (this.incomeCategories.indexOf('Employment') >= 0) {
      incomeQ16.answers.push('A40');
    }

    if (this.incomeCategories.indexOf('None') >= 0) {
      incomeQ16.answers.push('A41');
    }

    // Not in the swagger (As far as I am aware)
    if (this.incomeCategories.indexOf('Other') >= 0) {
      incomeQ16.answers.push(`${this.incomeOther}`);
    }
    // Not in the swagger (As far as I am aware)

    if (incomeQ16.answers.length !== 0) {
      qArr.push(incomeQ16);
    }

    // Total Income
    if (this.totalIncome) {
      let totalIncomeAnsID = '';
      switch (this.totalIncome) {
        case 'Less than $10,000':
          totalIncomeAnsID = 'A42';
          break;
        case '$10,000 to $14,999':
          totalIncomeAnsID = 'A43';
          break;
        case '$15,000 to $19,999':
          totalIncomeAnsID = 'A44';
          break;
        case '$20,000 to $24,999':
          totalIncomeAnsID = 'A45';
          break;
        case '$25,000 to $29,999':
          totalIncomeAnsID = 'A46';
          break;
        case '$30,000 to $34,999':
          totalIncomeAnsID = 'A47';
          break;
        case '$35,000 or more':
          totalIncomeAnsID = 'A48';
          break;
        default:
          break;
      }
      qArr.push(
        {
          questionId: 'Q17',   // Total Income
          answers: [
            totalIncomeAnsID
          ]
        }
      );
    }

    // Housing Type
    if (this.housingType) {
      let housingTypeAnsID = '';
      switch (this.housingType) {
        case 'Transitional/temporary housing':
          housingTypeAnsID = 'A49';
          break;
        case 'Permanent housing':
          housingTypeAnsID = 'A50';
          break;
        case 'Not housed (homeless)':
          housingTypeAnsID = 'A51';
          break;
        default:
          break;
      }
      qArr.push(
        {
          questionId: 'Q18',   // Housing Type
          answers: [
            housingTypeAnsID
          ]
        }
      );
    }

    const homelessQ19 = {
      questionId: 'Q19',
      answers: []
    }

    // If homeless, choose type
    if (this.homelessRadio) {
      switch (this.homelessRadio) {
        case 'Living in a place not meant for human habitation (for example, car)':
          homelessQ19.answers.push('A52');
          break;
        case 'In an emergency shelter':
          homelessQ19.answers.push('A53');
          break;
        case 'Homeless but admitted to a hospital or other institution for less than 30 days':
          homelessQ19.answers.push('A54');
          break;
        case 'At imminent risk of losing housing':
          homelessQ19.answers.push('A55');
          break;
        case 'Evicted or foreclosure within 30 days with no future residence identified':
          homelessQ19.answers.push('A56');
          break;
        case 'Couch surfing or doubled up':
          homelessQ19.answers.push('A57');
          break;
        case 'Other':               // If homeless, choose type
          homelessQ19.answers.push('A58');
          break;
        default:
          break;
      }

      // If Other is selected, add AOTXT only
      if (this.homelessOther) {
        homelessQ19.answers.push('AOTXT');  // If homeless, choose type - Other - AOTXT identifier
      }
    }

    if (homelessQ19.answers.length !== 0) {
      qArr.push(homelessQ19);
    }

    const strengthsQ20 = {
      questionId: 'Q20',
      answers: []
    }

    // Housing Assessment - strengths
    if (this.strengthsCategories.indexOf('Arranging apartment repairs') >= 0) {
      strengthsQ20.answers.push('A59');
    }

    if (this.strengthsCategories.indexOf('Desire to work or engage in community activities') >= 0) {
      strengthsQ20.answers.push('A60');
    }

    if (this.strengthsCategories.indexOf('Driving/using public transportation') >= 0) {
      strengthsQ20.answers.push('A61');
    }

    if (this.strengthsCategories.indexOf('Filling prescriptions') >= 0) {
      strengthsQ20.answers.push('A62');
    }

    if (this.strengthsCategories.indexOf('Getting along with neighbors, landlords, etc.') >= 0) {
      strengthsQ20.answers.push('A63');
    }

    if (this.strengthsCategories.indexOf('Housekeeping') >= 0) {
      strengthsQ20.answers.push('A64');
    }

    if (this.strengthsCategories.indexOf('Hygiene') >= 0) {
      strengthsQ20.answers.push('A65');
    }

    if (this.strengthsCategories.indexOf('Lease compliance') >= 0) {
      strengthsQ20.answers.push('A66');
    }

    if (this.strengthsCategories.indexOf('Long-term rental history') >= 0) {
      strengthsQ20.answers.push('A67');
    }

    if (this.strengthsCategories.indexOf('Maintaining benefits') >= 0) {
      strengthsQ20.answers.push('A68');
    }

    if (this.strengthsCategories.indexOf('Managing health care needs') >= 0) {
      strengthsQ20.answers.push('A69');
    }

    if (this.strengthsCategories.indexOf('Managing/using caregivers') >= 0) {
      strengthsQ20.answers.push('A70');
    }

    if (this.strengthsCategories.indexOf('Meal preparation') >= 0) {
      strengthsQ20.answers.push('A71');
    }

    if (this.strengthsCategories.indexOf('Money management') >= 0) {
      strengthsQ20.answers.push('A72');
    }

    if (this.strengthsCategories.indexOf('Motivated to obtain housing') >= 0) {
      strengthsQ20.answers.push('A73');
    }

    if (this.strengthsCategories.indexOf('Motivated to resolve legal/credit issues') >= 0) {
      strengthsQ20.answers.push('A74');
    }

    if (this.strengthsCategories.indexOf('Paying bills') >= 0) {
      strengthsQ20.answers.push('A75');
    }

    if (this.strengthsCategories.indexOf('Paying rent/utilities') >= 0) {
      strengthsQ20.answers.push('A76');
    }

    if (this.strengthsCategories.indexOf('Shopping for food and necessities') >= 0) {
      strengthsQ20.answers.push('A77');
    }

    if (this.strengthsCategories.indexOf('Support from family/friends') >= 0) {
      strengthsQ20.answers.push('A78');
    }

    if (this.strengthsCategories.indexOf('Taking medication') >= 0) {
      strengthsQ20.answers.push('A79');
    }

    if (this.strengthsCategories.indexOf('Other') >= 0) {
      strengthsQ20.answers.push('A80');
    }

    // If Other is selected, add AOTXT only
    if (this.otherStrengths) {
      strengthsQ20.answers.push('AOTXT');
    }

    if (strengthsQ20.answers.length !== 0) {
      qArr.push(strengthsQ20);
    }

    // Q21 - What type of housing location is preferred by the client?
    if (this.preferredHousingLocation) {
      let housingLocationAnsID = '';
      switch (this.preferredHousingLocation) {
        case 'Urban/Downtown':
          housingLocationAnsID = 'A81';
          break;
        case 'Urban/Residential Neighborhood':
          housingLocationAnsID = 'A82';
          break;
        case 'Suburban':
          housingLocationAnsID = 'A83';
          break;
        case 'Rural/Small Town':
          housingLocationAnsID = 'A84';
          break;
        default:
          break;
      }
      if (housingLocationAnsID) {
        qArr.push({
          questionId: 'Q21',
          answers: [housingLocationAnsID]
        });
      }
    }

    const closeToQ22 = {
      questionId: 'Q22',
      answers: []
    };

    // Close To
    if (this.closeToCat.indexOf("Transportation") >= 0) {
      closeToQ22.answers.push(`A85`);
    }

    if (this.closeToCat.indexOf("Recreation/Cultural") >= 0) {
      closeToQ22.answers.push(`A86`);
    }

    if (this.closeToCat.indexOf("Shopping") >= 0) {
      closeToQ22.answers.push(`A87`);
    }

    if (this.closeToCat.indexOf("Medical Services") >= 0) {
      closeToQ22.answers.push(`A88`);
    }

    if (this.closeToCat.indexOf("Family/Friends") >= 0) {
      closeToQ22.answers.push(`A89`);
    }

    if (this.closeToCat.indexOf("Place of Worship") >= 0) {
      closeToQ22.answers.push(`A90`);
    }

    if (this.closeToCat.indexOf("Transportation") >= 0) {
      closeToQ22.answers.push('A91');
    }

    // Not in the JSON
    if (this.otherCloseTo) {
      closeToQ22.answers.push(`${this.otherCloseTo}`);
    }
    // Not in the JSON

    if (closeToQ22.answers.length !== 0) {
      qArr.push(closeToQ22);
    }

    const livingSpaceQ23 = {
      questionId: 'Q23',
      answers: []
    };

    // Living Space
    if (this.livingSpaceCat.indexOf("Studio") >= 0) {
      livingSpaceQ23.answers.push(`A92`);
    }

    if (this.livingSpaceCat.indexOf("1 Bedroom") >= 0) {
      livingSpaceQ23.answers.push(`A93`);
    }

    if (this.livingSpaceCat.indexOf("2 Bedroom") >= 0) {
      livingSpaceQ23.answers.push(`A94`);
    }

    if (this.livingSpaceCat.indexOf("Onsite Laundry") >= 0) {
      livingSpaceQ23.answers.push(`A95`);
    }

    if (this.livingSpaceCat.indexOf("Nonsmoking") >= 0) {
      livingSpaceQ23.answers.push(`A96`);
    }

    if (this.livingSpaceCat.indexOf("Smoking Allowed") >= 0) {
      livingSpaceQ23.answers.push(`A97`);
    }

    if (this.livingSpaceCat.indexOf("Pets Allowed") >= 0) {
      livingSpaceQ23.answers.push(`A98`);
    }

    if (this.livingSpaceCat.indexOf("Bottom Floor/Elevator") >= 0) {
      livingSpaceQ23.answers.push(`A99`);
    }

    if (this.livingSpaceCat.indexOf("Accessible Unit") >= 0) {
      livingSpaceQ23.answers.push(`A100`);
    }

    if (this.livingSpaceCat.indexOf("Parking") >= 0) {
      livingSpaceQ23.answers.push(`A101`);
    }

    if (livingSpaceQ23.answers.length !== 0) {
      qArr.push(livingSpaceQ23);
    }

    // Please describe other relevant housing preferences
    if (this.housingPreferenceDescription) {
      qArr.push(
        {
          questionId: 'Q24',
          answers: [
            `${this.housingPreferenceDescription}`
          ]
        }
      );
    }

    if (this.personalInformationObj.wheelChairRadio) {
      qArr.push({
        questionId: 'Q25',
        answers: [`${this.personalInformationObj.wheelChairRadio === 'Yes' ? 'A102' : 'A103'}`]
      });
    }

    // Answer KV in JSON asking for string (units?) and number
    if (this.personalInformationObj.wheelWidth) {
      qArr.push({
        questionId: 'Q26',
        answers: [`${this.personalInformationObj.wheelWidth}`]
      })
    }

    if (this.personalInformationObj.manualElectric) {
      qArr.push({
        questionId: 'Q27',
        answers: [`${this.personalInformationObj.manualElectric}`]
      })
    }

    if (this.personalInformationObj.petRadio) {
      qArr.push(
        {
          questionId: 'Q28',  // Does the client have a pet?
          answers: [
            `${this.personalInformationObj.petRadio === 'Yes' ? `A104` : `A105`}`
          ]
        }
      );
    }

    if (this.personalInformationObj.serviceAnimalRadio) {
      qArr.push(
        {
          questionId: 'Q29',  // Does the client have a service animal?
          answers: [
            `${this.personalInformationObj.serviceAnimalRadio === 'Yes' ? `A106` : `A107`}`
          ]
        }
      );
    }

    if (this.personalInformationObj.smokeRadio) {
      qArr.push(
        {
          questionId: 'Q30',  // Does the client smoke?
          answers: [
            `${this.personalInformationObj.smokeRadio === 'Yes' ? `A108` : `A109`}`
          ]
        }
      );
    }

    if (this.personalInformationObj.marijuanaRadio) {
      qArr.push(
        {
          questionId: 'Q31',  // Does the client use medical marijuana?
          answers: [
            `${this.personalInformationObj.marijuanaRadio === 'Yes' ? `A110` : `A111`}`
          ]
        }
      );
    }

    if (this.personalInformationObj.dischargeRadio) {
      qArr.push(
        {
          questionId: 'Q32',  // Has the client served in the U.S. military with a qualified discharge?
          answers: [
            `${this.personalInformationObj.dischargeRadio === 'Yes' ? `A112` : `A113`}`
          ]
        }
      );
    }

    if (this.personalInformationObj.arrestedRadio) {
      qArr.push(
        {
          questionId: 'Q33',  // Has the client ever been arrested?
          answers: [
            `${this.personalInformationObj.arrestedRadio === 'Yes' ? `A114` : `A115`}`
          ]
        }
      );
    }

    if (this.personalInformationObj.crimeRadio) {
      qArr.push(
        {
          questionId: 'Q34',  // If yes, was the client charged and convicted of a crime?
          answers: [
            `${this.personalInformationObj.crimeRadio === 'Yes' ? `A116` : `A117`}`
          ]
        }
      );
    }

    if (this.personalInformationObj.convictedRadio) {
      qArr.push(
        {
          questionId: 'Q35',  // Is the client a registered sex offender or been convicted of manufacturing meth?
          answers: [
            `${this.personalInformationObj.convictedRadio === 'Yes' ? `A118` : `A119`}`
          ]
        }
      );
    }

    if (this.personalInformationObj.livingWithClientRadio) {
      qArr.push(
        {
          questionId: 'Q36',  // Will anyone else be living with the client?
          answers: [
            `${this.personalInformationObj.livingWithClientRadio === 'Yes' ? `A120` : `A121`}`
          ]
        }
      );
    }

    if (this.personalInformationObj.famPartFriend) {
      qArr.push({
        questionId: 'Q37',
        answers: [`${this.personalInformationObj.famPartFriend}`]
      });
    }

    if (this.personalInformationObj.aidField) {
      qArr.push({
        questionId: 'Q38',
        answers: [`${this.personalInformationObj.aidField}`]
      });
    }

    // Please describe other relevant personal information related to housing placement
    if (this.personalInformationObj.housingPreference) {
      qArr.push(
        {
          questionId: 'Q39',
          answers: [
            `${this.personalInformationObj.housingPreference}`
          ]
        }
      );
    }

    // Housing Assessment - Housing History
    if (this.personalInformationObj.rentalRadio) {
      qArr.push(
        {
          questionId: 'Q40',  // Does the client have any rental history?
          answers: [
            `${this.personalInformationObj.rentalRadio === 'Yes' ? `A122` : `A123`}`
          ]
        }
      );
    }

    if (this.personalInformationObj.subsidizedHousingRadio) {
      qArr.push(
        {
          questionId: 'Q41',  // Has the client ever received subsidized housing from a public housing authority?
          answers: [
            `${this.personalInformationObj.subsidizedHousingRadio === 'Yes' ? `A124` : `A125`}`
          ]
        }
      );
    }

    if (this.personalInformationObj.pastDueRadio) {
      qArr.push(
        {
          questionId: 'Q42',  // Does the client owe anyone or any public housing authority past-due rent?
          answers: [
            `${this.personalInformationObj.pastDueRadio === 'Yes' ? `A126` : `A127`}`
          ]
        }
      );
    }

    if (this.personalInformationObj.evictedRentalRadio) {
      qArr.push(
        {
          questionId: 'Q43',  // Has the client ever been evicted from rental housing?
          answers: [
            `${this.personalInformationObj.evictedRentalRadio === 'Yes' ? `A128` : `A129`}`
          ]
        }
      );
    }

    // If yes, please list dates
    // Answer KVs list two strings (multiple dates?)
    if (this.personalInformationObj.evictedDatesField) {
      qArr.push(
        {
          questionId: 'Q44',
          answers: [
            `${this.personalInformationObj.evictedDatesField}`
          ]
        }
      );
    }

    // Housing Assessment - Transportation Information
    if (this.publicTrasportationRadio) {
      qArr.push(
        {
          questionId: 'Q45',  // Does the client rely on public transportation?
          answers: [
            `${this.publicTrasportationRadio === 'Yes' ? `A130` : `A131`}`
          ]
        }
      );
    }

    if (this.vehicleRadio) {
      qArr.push(
        {
          questionId: 'Q46',  // Does the client have a vehicle?
          answers: [
            `${this.vehicleRadio === 'Yes' ? `A132` : `A133`}`
          ]
        }
      );
    }

    // Please describe the client transportation needs
    if (this.transportationDescription) {
      qArr.push(
        {
          questionId: 'Q47',
          answers: [
            `${this.transportationDescription}`
          ]
        }
      );
    }

    // Housing Assessment - Housing options to review/explore
    if (this.individualHousingRadio) {
      qArr.push(
        {
          questionId: 'Q48',  // Are any of the options below available and appropriate for the individual?
          answers: [
            `${this.individualHousingRadio === 'Yes' ? `A134` : `A135`}`
          ]
        }
      );
    }

    const rentalQ49 = {
      questionId: 'Q49',
      answers: []
    };

    // Housing Assessment - Tenant-based rental assistance
    if (this.rentalAssistanceCat.indexOf("Housing choice") >= 0) {
      rentalQ49.answers.push(`A136`);
    }

    if (this.rentalAssistanceCat.indexOf("Non-elderly disabled") >= 0) {
      rentalQ49.answers.push(`A137`);
    }

    if (this.rentalAssistanceCat.indexOf("Veteran’s Assistance Supportive Housing") >= 0) {
      rentalQ49.answers.push(`A138`);
    }

    if (this.rentalAssistanceCat.indexOf("Family Unification Program") >= 0) {
      rentalQ49.answers.push(`A139`);
    }

    if (this.rentalAssistanceCat.indexOf("Housing Opportunities for Persons With AIDS (HOPWA)") >= 0) {
      rentalQ49.answers.push(`A140`);
    }

    if (this.rentalAssistanceCat.indexOf("Other") >= 0) {
      rentalQ49.answers.push('A141');
    }

    if (this.otherRentalAssistanceDetails) {
      rentalQ49.answers.push(`${this.otherRentalAssistanceDetails}`);
    }

    if (rentalQ49.answers.length !== 0) {
      qArr.push(rentalQ49);
    }

    const rentalQ50 = {
      questionId: 'Q50',
      answers: []
    };

    // Housing Assessment - Project-based rental subsidy
    if (this.rentalSubsidyCategories.indexOf("HUD 811 (supportive housing for persons with disabilities)") >= 0) {
      rentalQ50.answers.push(`A142`);
    }

    if (this.rentalSubsidyCategories.indexOf("HUD 202 (supportive housing for the elderly)") >= 0) {
      rentalQ50.answers.push(`A143`);
    }

    if (this.rentalSubsidyCategories.indexOf("Low-Income Housing Tax Credit") >= 0) {
      rentalQ50.answers.push(`A144`);
    }

    if (this.rentalSubsidyCategories.indexOf("Other") >= 0) {
      rentalQ50.answers.push('A145');
    }

    // Not in the JSON
    if (this.otherRentalSubsidyDetails) {
      rentalQ50.answers.push(`${this.otherRentalSubsidyDetails}`);
    }
    // Not in the JSON

    if (rentalQ50.answers.length !== 0) {
      qArr.push(rentalQ50);
    }

    // Housing Assessment - Continuum of care

    const contOfCareQ51 = {
      questionId: 'Q51',
      answers: []
    }

    if (this.continuumOfCareCat.indexOf("Shelter care") >= 0) {
      contOfCareQ51.answers.push(`A146`);
    }

    if (this.continuumOfCareCat.indexOf("Homelessness Prevention and Rapid Re-Housing Program (HPRP)") >= 0) {
      contOfCareQ51.answers.push(`A147`);
    }

    if (this.continuumOfCareCat.indexOf("Permanent supportive housing") >= 0) {
      contOfCareQ51.answers.push(`A148`);
    }

    if (this.continuumOfCareCat.indexOf("Transitional housing") >= 0) {
      contOfCareQ51.answers.push(`A149`);
    }

    if (this.continuumOfCareCat.indexOf("Other") >= 0) {
      contOfCareQ51.answers.push('A150');
    }

    // Not in the JSON
    if (this.otherContinuumOfCareDetails) {
      contOfCareQ51.answers.push(`${this.otherContinuumOfCareDetails}`);
    }
    // Not in the JSON

    if (contOfCareQ51.answers.length !== 0) {
      qArr.push(contOfCareQ51);
    }

    if (this.deptOfCommerceSubsidized) {
      qArr.push(
        {
          questionId: 'Q52',  // Department of Commerce subsidized
          answers: [
            `${this.deptOfCommerceSubsidized}`
          ]
        }
      );
    }

    if (this.otherHUDOrUSDASubsidy) {
      qArr.push(
        {
          questionId: 'Q53',  // Other HUD or USDA subsidy
          answers: [
            `${this.otherHUDOrUSDASubsidy}`
          ]
        }
      );
    }

    if (this.countyOrCityProgram) {
      qArr.push(
        {
          questionId: 'Q54',  // County/city program
          answers: [
            `${this.countyOrCityProgram}`
          ]
        }
      );
    }

    if (this.otherProgramsDetails) {
      qArr.push(
        {
          questionId: 'Q55',  // Other
          answers: [
            `${this.otherProgramsDetails}`
          ]
        }
      );
    }

    // const documentQ56 = {
    //   questionId: 'Q56',
    //   answers: []
    // };

    // Documentation
    this.housingAssessmentFormData.attachments = this.attachments.map(doc => (
      {
        documentName: doc.shortenedName,
        documentId: '',
        fileName: doc.updatedFileName,
        filePath: ''
      }
    ));

    // if (this.documentCategories.indexOf("Social security card") >= 0) {
    //   documentQ56.answers.push(`A151`);
    // }

    // if (this.documentCategories.indexOf("Background check results") >= 0) {
    //   documentQ56.answers.push(`A152`);
    // }

    // if (this.documentCategories.indexOf("Proof of income") >= 0) {
    //   documentQ56.answers.push(`A153`);
    // }

    // if (this.documentCategories.indexOf("Documentation of other assets") >= 0) {
    //   documentQ56.answers.push(`A154`);
    // }

    // if (this.documentCategories.indexOf("Birth certificate") >= 0) {
    //   documentQ56.answers.push(`A155`);
    // }

    // if (this.documentCategories.indexOf("Legal resident status") >= 0) {
    //   documentQ56.answers.push(`A156`);
    // }

    // if (this.documentCategories.indexOf("Protective payee") >= 0) {
    //   documentQ56.answers.push(`A157`);
    // }

    // if (this.suppDocRadio) {
    //   documentQ56.answers.push(`${this.suppDocRadio === 'Yes' ? 'A158' : 'A159'}`);
    // }

    // if (this.documentNotes) {
    //   documentQ56.answers.push(`${this.documentNotes}`);
    // }

    // if (documentQ56.answers.length !== 0) {
    //   qArr.push(documentQ56);
    // }

    // AHAH-RAP Attestations
    if(this.ahahChronicHomelessness.ahahChronicRadio === 'Yes') {
      this.housingAssessmentFormData.enrolleeConsent.Attestations.push(
        {
          ecCode: 'ATT01',
          ecValue: 'I have experienced being homeless for the last 12 months in which I lived in a place not meant for human habitation, in a safe haven or in an emergency shelter, or on at least four separate occasions in the last three years, I was homeless for a total of at least 12 months',
          ecName: this.ahahChronicHomelessness.ahahChronicFirstLast
        }
      )
    }

    if(this.ahahFreqResCareStay.ahahFreqResRadio === 'Yes') {
      this.housingAssessmentFormData.enrolleeConsent.Attestations.push(
        {
          ecCode: 'ATT02',
          ecValue: 'I have experienced frequent residential care stays as defined above',
          ecName: this.ahahFreqResCareStay.ahahFreqResStayFirstLast
        }
      )
    }

    if(this.ahahLengthyInstContacts.ahahLengthyRadio === 'Yes') {
      this.housingAssessmentFormData.enrolleeConsent.Attestations.push(
        {
          ecCode: 'ATT03',
          ecValue: 'I have experienced frequent and/or lengthy institutional contacts as defined above',
          ecName: this.ahahLengthyInstContacts.ahahLengthyFirstLast
        }
      )
    }

    const provAgencyName = this.getProviderAgencyName(this.assessmentReporter);
    const provAgencyId = this.getProvAgencyId(this.assessmentReporter)
    // Signatures - Assessment Reporter
    if(provAgencyId) {
      this.housingAssessmentFormData.providerAgency.id = provAgencyId;
    }
    this.housingAssessmentFormData.providerAgency.reporter.firstName = this.assessmentReporter.reporterFirst;
    this.housingAssessmentFormData.providerAgency.reporter.lastName = this.assessmentReporter.reporterLast;
    this.housingAssessmentFormData.providerAgency.reporter.positionCredentials = this.assessmentReporter.positionCred;
    this.housingAssessmentFormData.providerAgency.reporter.date = this.assessmentReporter.reporterDate ?
      moment(this.assessmentReporter.reporterDate).format("YYYY-MM-DD") : "";
    this.housingAssessmentFormData.providerAgency.name = provAgencyName;
    this.housingAssessmentFormData.providerAgency.reporter.email = this.assessmentReporter.reporterEmail;
    this.housingAssessmentFormData.providerAgency.reporter.phoneNumber = this.assessmentReporter.reporterPhone;

    // Signatures - Assessment Supervisor

    this.housingAssessmentFormData.providerAgency.supervisor.lastName = this.assessmentSupervisor.supervisorLast;

    this.housingAssessmentFormData.providerAgency.supervisor.firstName = this.assessmentSupervisor.supervisorFirst;

    this.housingAssessmentFormData.providerAgency.supervisor.positionCredentials = this.assessmentSupervisor.supervisorPosCred;

    this.housingAssessmentFormData.providerAgency.supervisor.date = this.assessmentSupervisor.supervisorDate ?
      moment(this.assessmentSupervisor.supervisorDate).format("YYYY-MM-DD") : "";

    // Signatures - Enrollee consent for services
    this.housingAssessmentFormData.enrolleeConsent.lastName = this.enrolleeInformation.enrolleeLast;
    this.housingAssessmentFormData.enrolleeConsent.firstName = this.enrolleeInformation.enrolleeFirst;
    this.housingAssessmentFormData.enrolleeConsent.date = this.enrolleeInformation.enrolleeDate ?
      moment(this.enrolleeInformation.enrolleeDate).format("YYYY-MM-DD") : "";
    this.housingAssessmentFormData.enrolleeConsent.time = this.enrolleeInformation.time;

    if(this.signatureCategories.indexOf("I, the potential enrollee, confirm that all answers have been provided to the best of my knowledge.") >= 0) {
      this.housingAssessmentFormData.enrolleeConsent.Acknowledgements.push(
        {
          ecCode: 'ACK01',
          ecValue: 'I,the potential enrollee, confirm that all answers have been provided to the best of my knowledge'
        }
      );
    }

    if(this.signatureCategories.indexOf("shared with the Department of Commerce, landlords, property managers, and/or their third-part administrator") >= 0) {
      this.housingAssessmentFormData.enrolleeConsent.Acknowledgements.push(
        {
          ecCode: 'ACK02',
          ecValue: 'I understand that if I am selected for AHAH-RAP the information on this assessment will be shared with the Department of Commerce, landlords, property managers, and/or their third-party administrator solely for the purposes of connecting me to housing that aligns with my preferences and for program monitoring and evaluation.'
        }
      );
    }

    if(this.signatureCategories.indexOf("Verbal consent was received from the potential enrollee.") >= 0) {
      this.housingAssessmentFormData.enrolleeConsent.Acknowledgements.push(
        {
          ecCode: 'ACK03',
          ecValue: 'Verbal consent was received from the potential enrollee. Note: Please print and retain this assessment form, signed by the potential enrollee, on file'
        }
      )
    }

    if(this.assessmentCategories.indexOf("FCS-AHAH_accurate_info") >= 0) {
      this.housingAssessmentFormData.enrolleeConsent.Acknowledgements.push(
        {
          ecCode: 'ACK04',
          ecValue: 'I, the FCS-SH Provider, worked with my potential enrollee to share accurate information to the best of my knowledge for the purpose of connecting the potential enrollee to the FCS and AHAH Rental Assistance Program.'
        }
      )
    }

    const notesQ56 =   {
      "questionId": "Q56",
      "answers": []
    }

    if(this.documentNotes) {
      notesQ56.answers.push(this.documentNotes);
    }

    if(notesQ56.answers.length !== 0) {
      qArr.push(notesQ56);
    }

    const signatureQ66 = {
      questionId: 'Q57',
      answers: []
    };

    if (this.signatureCategories.indexOf("Verbal consent was received from the potential enrollee.") >= 0) {
      signatureQ66.answers.push('A160');
    }

    if (signatureQ66.answers.length !== 0) {
      qArr.push(signatureQ66);
    }

    const homelessnessQ58 = {
      questionId: 'Q58',
      question: 'Is the potential enrollee experiencing homelessness?',
      answers: [],
      answerKVs: [
        {'id': 'A162', 'text': 'Yes'},
        {'id': 'A163', 'text': 'No'}
      ]
    };

    if(this.memberInfo.isHomeless) {
      homelessnessQ58.answers.push(`${this.memberInfo.isHomeless === 'Yes' ? 'A162' : 'A163'}`);
    }

    if(homelessnessQ58.answers.length !== 0) {
      qArr.push(homelessnessQ58);
    }

    const ahahChronicHomelessQ59 = {
      questionId: 'Q59',
      question: 'Does the Enrollee meet the AHAH definition of chronically homeless?',
      answerKVs: [
        {'id': 'A164', 'text': 'Yes'},
        {'id': 'A165', 'text': 'No'}
      ],
      answers: []
    };

    if(this.ahahChronicHomelessness.ahahChronicRadio) {
      ahahChronicHomelessQ59.answers.push(`${this.ahahChronicHomelessness.ahahChronicRadio === 'Yes' ? 'A164' : 'A165'}`);
    } 

    if(ahahChronicHomelessQ59.answers.length !== 0) {
      qArr.push(ahahChronicHomelessQ59);
    }

    const ahahFreqResCareStayQ60 = {
      questionId: 'Q60',
      question: 'Does the enrollee have frequent residential care stays (two or more occurrences in the past 12 months)?',
      answerKVs: [
        {'id': 'A166', 'text': 'Yes'},
        {'id': 'A167', 'text': 'No'}
      ],
      answers: []
    };

    if(this.ahahFreqResCareStay.ahahFreqResRadio) {
      ahahFreqResCareStayQ60.answers.push(`${this.ahahFreqResCareStay.ahahFreqResRadio === 'Yes' ? 'A166' : 'A167'}`);
    }

    if(ahahFreqResCareStayQ60.answers.length !== 0) {
      qArr.push(ahahFreqResCareStayQ60);
    }

    const ahahLengthyInstContactsQ61 = {
      questionId: 'Q61',
      question: 'Does the enrollee have frequent or lengthy institutional contacts (two or more instances in the past 12 months or 90 days or greater)?',
      answerKVs: [
        {'id': 'A168', 'text': 'Yes'},
        {'id': 'A169', 'text': 'No'}
      ],
      answers: []
    };

    if(this.ahahLengthyInstContacts.ahahLengthyRadio) {
      ahahLengthyInstContactsQ61.answers.push(`${this.ahahLengthyInstContacts.ahahLengthyRadio === 'Yes' ? 'A168' : 'A169'}`)
    }

    if(ahahLengthyInstContactsQ61.answers.length !== 0) {
      qArr.push(ahahLengthyInstContactsQ61);
    }

    const enrolleeEligibleForAHAHQ62 = {
      questionId: 'Q62',
      question: 'Would the potential enrollee like to be considered for the AHAH Rental Assistance Program (AHAH-RAP)?',
      answers: [],
      answerKVs: [
        {'id': 'A170', 'text': 'Yes'},
        {'id': 'A171', 'text': 'No'}
      ]
    };

    if(this.memberInfo.isHomeless === 'Yes' && this.memberInfo.isEnrolleeEligibleForAHAH) {
      enrolleeEligibleForAHAHQ62.answers.push(`${this.memberInfo.isEnrolleeEligibleForAHAH === 'Yes' ? 'A170' : 'A171'}`);
    }

    if(enrolleeEligibleForAHAHQ62.answers.length !== 0) {
      qArr.push(enrolleeEligibleForAHAHQ62);
    }

    // Q63 - Is the client housed?
    if (this.isClientHoused) {
      qArr.push({
        questionId: 'Q63',
        answers: [`${this.isClientHoused === 'Yes' ? 'A172' : 'A173'}`]
      });
    }

    // Q64 - What month did they get housed? (AODT format)
    if (this.dateHoused) {
      qArr.push({
        questionId: 'Q64',
        answers: ['AODT']
      });
    }

    // Q65 - What type of housing does the client currently live in?
    if (this.currentHousingType) {
      let currentHousingTypeAnsID = '';
      switch (this.currentHousingType) {
        case 'Project based (Services available on site)':
          currentHousingTypeAnsID = 'A174';
          break;
        case 'Scattered site':
          currentHousingTypeAnsID = 'A175';
          break;
        case 'Transitional program':
          currentHousingTypeAnsID = 'A176';
          break;
        case 'Recovery residence or sober living':
          currentHousingTypeAnsID = 'A177';
          break;
        case 'Single room occupancy':
          currentHousingTypeAnsID = 'A178';
          break;
        case 'Shared living':
          currentHousingTypeAnsID = 'A179';
          break;
        case 'Living with roommate(s) - market rate':
          currentHousingTypeAnsID = 'A180';
          break;
        case 'Other':
          currentHousingTypeAnsID = 'A181';
          break;
        default:
          break;
      }

      if (currentHousingTypeAnsID) {
        const currentHousingTypeQ65 = {
          questionId: 'Q65',
          answers: [currentHousingTypeAnsID]
        };

        // If Other is selected, add AOTXT only
        if (this.currentHousingType === 'Other' && this.currentHousingTypeOther) {
          currentHousingTypeQ65.answers.push('AOTXT');
        }

        qArr.push(currentHousingTypeQ65);
      }
    }

    // Q66 - Is the client's current housing at risk?
    if (this.housingAtRisk) {
      qArr.push({
        questionId: 'Q66',
        answers: [`${this.housingAtRisk === 'Yes' ? 'A182' : 'A183'}`]
      });
    }

    // Q67 - What type of housing is preferred by the client?
    if (this.preferredHousingType) {
      let preferredHousingTypeAnsID = '';
      switch (this.preferredHousingType) {
        case 'Project based (services available on site)':
          preferredHousingTypeAnsID = 'A184';
          break;
        case 'Scattered site':
          preferredHousingTypeAnsID = 'A185';
          break;
        case 'Transitional program':
          preferredHousingTypeAnsID = 'A186';
          break;
        case 'Recovery residence or sober living':
          preferredHousingTypeAnsID = 'A187';
          break;
        case 'Single room occupancy':
          preferredHousingTypeAnsID = 'A188';
          break;
        case 'Shared living/living with roommate(s)':
          preferredHousingTypeAnsID = 'A189';
          break;
        case 'Living with roommate(s) - market rate':
          preferredHousingTypeAnsID = 'A190';
          break;
        case 'Other':
          preferredHousingTypeAnsID = 'A191';
          break;
        default:
          break;
      }

      if (preferredHousingTypeAnsID) {
        const preferredHousingTypeQ67 = {
          questionId: 'Q67',
          answers: [preferredHousingTypeAnsID]
        };

        // If Other is selected, add AOTXT only
        if (this.preferredHousingType === 'Other' && this.preferredHousingTypeOther) {
          preferredHousingTypeQ67.answers.push('AOTXT');
        }

        qArr.push(preferredHousingTypeQ67);
      }
    }

    // Q68 - Have goals been set for this authorization period?
    if (this.housingGoalsSet) {
      qArr.push({
        questionId: 'Q68',
        answers: [`${this.housingGoalsSet === 'Yes' ? 'A192' : 'A193'}`]
      });
    }

    // Q69 - How many goals are in their service plan for this authorization period? (AONBR format)
    if (this.housingGoalsCount) {
      qArr.push({
        questionId: 'Q69',
        answers: ['AONBR']
      });
    }

    // Q70 - How confident is the client in accomplishing these set goals within the authorization period?
    const housingGoalsConfidenceQ70 = {
      questionId: 'Q70',
      answers: []
    };

    if (this.housingGoalsConfidence) {
      switch (this.housingGoalsConfidence) {
        case 'Extremely confident':
          housingGoalsConfidenceQ70.answers.push('A194');
          break;
        case 'Very confident':
          housingGoalsConfidenceQ70.answers.push('A195');
          break;
        case 'Moderately confident':
          housingGoalsConfidenceQ70.answers.push('A196');
          break;
        case 'Slightly confident':
          housingGoalsConfidenceQ70.answers.push('A197');
          break;
        case 'Not at all confident':
          housingGoalsConfidenceQ70.answers.push('A198');
          break;
        default:
          break;
      }
    }

    if (housingGoalsConfidenceQ70.answers.length !== 0) {
      qArr.push(housingGoalsConfidenceQ70);
    }

    // Q71 - If yes, select the most appropriate reason(s)
    const housingAtRiskReasonsQ71 = {
      questionId: 'Q71',
      answers: []
    };

    if (this.housingAtRiskReasons.indexOf('Lease violations') >= 0) {
      housingAtRiskReasonsQ71.answers.push('A199');
    }

    if (this.housingAtRiskReasons.indexOf('Habitability issues') >= 0) {
      housingAtRiskReasonsQ71.answers.push('A200');
    }

    if (this.housingAtRiskReasons.indexOf('Issues with rent and/or other payments') >= 0) {
      housingAtRiskReasonsQ71.answers.push('A201');
    }

    if (this.housingAtRiskReasons.indexOf('Landlord issues') >= 0) {
      housingAtRiskReasonsQ71.answers.push('A202');
    }

    if (this.housingAtRiskReasons.indexOf('Other') >= 0) {
      housingAtRiskReasonsQ71.answers.push('A203');
    }

    // If Other is selected, add AOTXT only
    if (this.housingAtRiskReasons.indexOf('Other') >= 0 && this.housingAtRiskOther) {
      housingAtRiskReasonsQ71.answers.push('AOTXT');
    }

    if (housingAtRiskReasonsQ71.answers.length !== 0) {
      qArr.push(housingAtRiskReasonsQ71);
    }

    if (this.enrolleeInformation.enrolleeNotes) {
      this.housingAssessmentFormData.notes = this.enrolleeInformation.enrolleeNotes;
    }

    this.housingAssessmentFormData.questions = qArr;
    return this.housingAssessmentFormData;

  }

  getProviderAgencyName(assessmentReporter) {
    if(!assessmentReporter.providerAgency) {
      return "";
    }
    return typeof assessmentReporter.providerAgency === "string" ? assessmentReporter.providerAgency : assessmentReporter.providerAgency.label;
  }

  getProvAgencyId(assessmentReporter) {
    if(!assessmentReporter.providerAgency)
      return undefined;

    if (typeof assessmentReporter.providerAgency === 'string') {
      return undefined;
    }
    return this.assessmentReporter.providerAgency ? this.assessmentReporter.providerAgency.value : undefined;
  }

  @action clearHousingAssessmentFormOnHomelessness() {
    this.healthNeedCat = [];
    this.riskFactorsCategories = [];
    this.institutionalSettingsRadio = '';
    this.instSettingsCategories = [];
    this.multiInstSettingsRadio = '';
    this.countDetails = '';
    this.multiResidentialCareRadio = '';
    this.resCareFacilityCategories = [];
    this.multiInHomeCareRadio = '';
    this.additionalDetails = '';
    this.employmentCategories = [];
    this.incomeCategories = [];
    this.incomeOther = '';
    this.totalIncome = '';
    this.housingType = '';
    this.isClientHoused = '';
    this.dateHoused = '';
    this.homelessRadio = '';
    this.homelessOther = '';
    this.housingPreferenceCat = [];
    this.closeToCat = [];
    this.otherCloseTo = '';
    this.livingSpaceCat = [];
    this.housingPreferenceDescription = '';
    this.strengthsCategories = [];
    this.otherStrengths = '';
    this.publicTrasportationRadio = '';
    this.vehicleRadio = '';
    this.transportationDescription = '';
    this.individualHousingRadio = '';
    this.rentalAssistanceCat = [];
    this.otherRentalAssistanceDetails = '';
    this.rentalSubsidyCategories = [];
    this.otherRentalSubsidyDetails = '';
    this.continuumOfCareCat = [];
    this.otherContinuumOfCareDetails = '';
    this.otherHUDOrUSDASubsidy = '';
    this.countyOrCityProgram = '';
    this.otherProgramsDetails = '';
    this.housingGoalsSet = '';
    this.housingGoalsCount = '';
    this.housingGoalsConfidence = '';
    this.currentHousingType = '';
    this.currentHousingTypeOther = '';
    this.housingAtRisk = '';
    this.housingAtRiskReasons = [];
    this.housingAtRiskOther = '';
    this.preferredHousingType = '';
    this.preferredHousingTypeOther = '';
    this.preferredHousingLocation = '';
    this.deptOfCommerceSubsidized = '';
    this.assessmentCategories = [];
    this.signatureCategories = [];
    this.personalInformationObj = {
      wheelChairRadio: '',
      wheelWidth: '',
      manualElectric: '',
      petRadio: '',
      serviceAnimalRadio: '',
      smokeRadio: '',
      marijuanaRadio: '',
      dischargeRadio: '',
      arrestedRadio: '',
      crimeRadio: '',
      convictedRadio: '',
      livingWithClientRadio: '',
      famPartFriend: '',
      aidField: '',
      housingPreference: '',
      rentalRadio: '',
      subsidizedHousingRadio: '',
      pastDueRadio: '',
      evictedRentalRadio: '',
      evictedDatesField: ''
    }
    this.ahahChronicHomelessness = {
      ahahChronicRadio: '',
      ahahChronicFirstLast: ''
    }
    this.ahahFreqResCareStay = {
      ahahFreqResRadio: '',
      ahahFreqResStayFirstLast: ''
    }
    this.ahahLengthyInstContacts = {
      ahahLengthyRadio: '',
      ahahLengthyFirstLast: ''
    }
    this.documentCategories = [];
    this.documentNotes = '';
    this.assessmentReporter = {
      reporterLast: '',
      reporterFirst: '',
      positionCred: '',
      providerAgency: '',
      signature: '',
      reporterDate: '',
      reporterEmail: '',
      reporterPhone: ''
    }
    this.assessmentSupervisor = {
      supervisorLast: '',
      supervisorFirst: '',
      supervisorPosCred: '',
      superSignature: '',
      supervisorDate: ''
    }
    this.enrolleeInformation = {
      enrolleeLast: '',
      enrolleeFirst: '',
      enrolleeDate: '',
      enrolleeNotes: '',
      enrolleeSignature: '',
      enrolleeConsentReceived: '',
      time: ''
    }

    this.supportiveHousingPagesAHAH = [
      {title: 'Potential Enrollee Information', state: 'stepwizard-step active', href: '#', key: 0},
      {title: 'Complex Needs', state: 'stepwizard-step disabled', href: '#healthneeds', key: 1},
      {title: 'Housing Assessment', state: 'stepwizard-step disabled', href: '#housingassessment', key: 2},
      {title: 'AHAH-RAP', state: 'stepwizard-step disabled', href: '#ahah-rap', key: 3},
      {title: 'Signatures', state: 'stepwizard-step disabled', href: '#signature', key: 4},
      {title: 'Supporting Documentation', state: 'stepwizard-step disabled', href: '#documentation', key: 5},
      {title: 'Review & Submit', state: 'stepwizard-step disabled', href: '#reviewsubmit', key: 6},
    ];
  
    this.supportiveHousingPagesNoAHAH = [
      {title: 'Potential Enrollee Information', state: 'stepwizard-step active', href: '#', key: 0},
      {title: 'Complex Needs', state: 'stepwizard-step disabled', href: '#healthneeds', key: 1},
      {title: 'Housing Assessment', state: 'stepwizard-step disabled', href: '#housingassessment', key: 2},
      {title: 'Signatures', state: 'stepwizard-step disabled', href: '#signature', key: 3},
      {title: 'Supporting Documentation', state: 'stepwizard-step disabled', href: '#documentation', key: 4},
      {title: 'Review & Submit', state: 'stepwizard-step disabled', href: '#reviewsubmit', key: 5}
    ]

    this.supportiveHousingRoutesAHAH = [
      { title: 'Potential Enrollee Information', state: 'active', route: '/', key: 0 },
      { title: 'Health Needs', state: 'inactive', route: '/healthneeds', key: 1 },
      { title: 'Risk Factors', state: 'inactive', route: '/riskfactors', key: 2 },
      { title: 'Housing Assessment', state: 'inactive', route: '/housingassessment', key: 3 },
      { title: 'Strengths', state: 'inactive', route: '/strengths', key: 4 },
      { title: 'Housing Preference', state: 'inactive', route: '/housingpreference', key: 5 },
      { title: 'Personal Housing History', state: 'inactive', route: '/personalhousinghist', key: 6 },
      { title: 'Transportation Information', state: 'inactive', route: '/transportationinformation', key: 7 },
      { title: 'AHAH RAP', state: 'inactive', route: '/ahah-rap', key: 8 },
      { title: 'Signature', state: 'inactive', route: '/signature', key: 9 },
      { title: 'Documentation', state: 'inactive', route: '/documentation', key: 10 },
      { title: 'Review & Submit', state: 'inactive', route: '/reviewsubmit', key: 11 },
    ];;
  
    this.supportiveHousingRoutesNoAHAH = [
      { title: 'Potential Enrollee Information', state: 'active', route: '/', key: 0 },
      { title: 'Health Needs', state: 'inactive', route: '/healthneeds', key: 1 },
      { title: 'Risk Factors', state: 'inactive', route: '/riskfactors', key: 2 },
      { title: 'Housing Assessment', state: 'inactive', route: '/housingassessment', key: 3 },
      { title: 'Strengths', state: 'inactive', route: '/strengths', key: 4 },
      { title: 'Housing Preference', state: 'inactive', route: '/housingpreference', key: 5 },
      { title: 'Personal Housing History', state: 'inactive', route: '/personalhousinghist', key: 6 },
      { title: 'Transportation Information', state: 'inactive', route: '/transportationinformation', key: 7 },
      { title: 'Signature', state: 'inactive', route: '/signature', key: 8 },
      { title: 'Documentation', state: 'inactive', route: '/documentation', key: 9 },
      { title: 'Review & Submit', state: 'inactive', route: '/reviewsubmit', key: 10 },
    ];
    
  }
}

export default new HousingStore();
